import Axios from 'lib/Axios';
import { APIResponse } from 'types/APIResponse';
import { BatteryPower } from 'types/BatteryPower';
import { ManufacturerCountry } from 'types/ManufacturerCountry';
import { OilKm, OilViscosity } from 'types/Oil';
import { Rims } from 'types/Rims';
import { Tyre } from 'types/Tyres';

export const _GetTyres = () => Axios.get<APIResponse<Tyre[]>>('/lookups/tyres').then((res) => res.data);

export const _GetRims = () => Axios.get<Rims>('/lookups/rim').then((res) => res.data);

export const _GetBatteryPower = () => Axios.get<BatteryPower>('/lookups/battery_power').then((res) => res.data);

export const _GetOilKm = () => Axios.get<OilKm>('/lookups/km').then((res) => res.data);

export const _GetOilViscosity = () => Axios.get<OilViscosity>('/lookups/oil_viscosity').then((res) => res.data);

export const _GetManufacturerCountry = () =>
  Axios.get<APIResponse<ManufacturerCountry[]>>('/lookups/manufacturer_country').then((res) => res.data);
